<li class="nav-item dropdown">
  <a href="javascript:void(0)" class="nav-link dropdown-toggle" data-toggle="dropdown">{{nav.dropDownTitle}}</a>
  <ul class="dropdown_menu dropdown-menu">
      <li class="nav-item">
          <a (click)="onClick()" [routerLink]="nav.url" [routerLinkActiveOptions]="{exact: true}" routerLinkActive="active">{{nav.title}}</a>
      </li>
      <app-nav-item (selected)="onClick()" *ngFor="let item of nav.options" [nav]="item"></app-nav-item>
  </ul>
</li>
